export const collection_places = process.env.REACT_APP_COLLECTION
export const google_api_key = 'AIzaSyAjEc36WWK9258bpGJGqfb_Pa7KcE7Mo6o'